angular.module("core")
.controller("ConfirmPasswordModalController", function(
    $rootScope, $scope, FormError, close, FlashBag, $attrs
) {
    var _this = this;

    var sharedScope = $attrs.sharedScope;
    var scopeName = $attrs.scopeName;

    var unregisterSuccess = sharedScope.$on("formSubmissionSucceeded" + scopeName, function() {
        _this.close();
    });

    var unregisterFailed = sharedScope.$on("formSubmissionFailed" + scopeName, function(event, response, showError) {
        if ($scope.FormPassword && $scope.FormPassword.Password && response.data["password"]) {
            $scope.FormPassword.Password.$setValidity("submitError", false);
            _this.errorMessage = response.data["password"];
        }
        else {
            if (showError) {
                FlashBag.apiError(response);
            }
            _this.close();
        }
    });

    $scope.$on("$destroy", function() {
        unregisterSuccess();
        unregisterFailed();
    });

    this.close = function(confirm) {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    this.submit = function() {
        $scope.FormPassword.$setSubmitted();
        if (!$scope.FormPassword.$valid) {
            FormError.focus("formPassword");
        }
        else {
            sharedScope.$emit("submitForm" + scopeName, {password: $scope.Form.password});
        }
    };

    this.passwordChanged = function() {
        if ($scope.FormPassword && $scope.FormPassword.Password) {
            $scope.FormPassword.Password.$setValidity("submitError", true);
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/confirm-password/confirm-password.modal.js
// module id = 669
// module chunks = 0